<template>
  <div class="clouds">
    <img v-for="(cloud, i) in clouds" src="../../assets/imgs/cloud.png" :ref="`cloud0`+cloud" :key="i" :class="`cloud cld-0`+cloud" />

  </div>
</template>

<script>
import { inject } from "vue";
import gsap from 'gsap';

export default {
  name: "Clouds",
  data() {
    return {
      clouds: [1, 2, 3, 4, 5, 6,  7, 8, 9 ,10, 11, 12]
    }
  },
  setup() {
    const store = inject("store");
    return {
      state: store.state,
			actions: store.actions
    };
  },
  mounted() {
    this.startClouds();
  },
	methods: {
		startClouds() {
      var cld1 = gsap.timeline({repeat: -1, yoyo: true});
      cld1.to(this.$refs.cloud01, { x: 200, duration: 20});
      cld1.to(this.$refs.cloud01, { x: 0, duration: 20});

      var cld2 = gsap.timeline({repeat: -1, yoyo: true});
      cld2.set(this.$refs.cloud02, { x: 400, duration: 40});
      cld2.to(this.$refs.cloud02, { x: 350, duration: 10});
      cld2.to(this.$refs.cloud02, { x: 400, duration: 40});

      var cld3 = gsap.timeline({repeat: -1, yoyo: true});
      cld3.set(this.$refs.cloud03, { x: 175, y: 80, scale: 0.7, duration: 20});
      cld3.to(this.$refs.cloud03, { x: 150, y: 80, duration: 10});
      cld3.to(this.$refs.cloud03, { x: 50, y: 80, duration: 40});

      var cld4 = gsap.timeline({repeat: -1, yoyo: true});
      cld4.set(this.$refs.cloud04, { x: 175, y: 220, scale: 0.5, duration: 20});
      cld4.to(this.$refs.cloud04, { x: 150, y: 220, duration: 10});
      cld4.to(this.$refs.cloud04, { x: 175, y: 220, duration: 40});

      var cld5 = gsap.timeline({repeat: -1, yoyo: true});
      cld5.set(this.$refs.cloud05, { x: 175, y: 190, scale: 0.8, duration: 20});
      cld5.to(this.$refs.cloud05, { x: 150, y: 190, duration: 10});
      cld5.to(this.$refs.cloud05, { x: 175, y: 190, duration: 40});

      var cld6 = gsap.timeline({repeat: -1, yoyo: true});
      cld6.to(this.$refs.cloud06, { x: 400, duration: 20});
      cld6.to(this.$refs.cloud06, { x: 600, duration: 20});

      var cld7 = gsap.timeline({repeat: -1, yoyo: true});
      cld7.set(this.$refs.cloud07, { x: 800, duration: 40});
      cld7.to(this.$refs.cloud07, { x: 600, duration: 10});
      cld7.to(this.$refs.cloud07, { x: 800, duration: 40});

      var cld8 = gsap.timeline({repeat: -1, yoyo: true});
      cld8.set(this.$refs.cloud08, { x: 475, y: 100, scale: 0.3, duration: 20});
      cld8.to(this.$refs.cloud08, { x: 450, y: 100, duration: 10});
      cld8.to(this.$refs.cloud08, { x: 350, y: 100, duration: 40});

      var cld9 = gsap.timeline({repeat: -1, yoyo: true});
      cld9.set(this.$refs.cloud09, { x: 375, y: 270, scale: 0.5, duration: 20});
      cld9.to(this.$refs.cloud09, { x: 350, y: 270, duration: 10});
      cld9.to(this.$refs.cloud09, { x: 375, y: 270, duration: 40});

      var cld010 = gsap.timeline({repeat: -1, yoyo: true});
      cld010.set(this.$refs.cloud010, { x: 575, y: 210, scale: 0.8, duration: 20});
      cld010.to(this.$refs.cloud010, { x: 550, y: 210, duration: 10});
      cld010.to(this.$refs.cloud010, { x: 575, y: 210, duration: 40});

      var cld011 = gsap.timeline({repeat: -1, yoyo: true});
      cld011.set(this.$refs.cloud011, { x: 75, y: 270, scale: 0.5, duration: 20});
      cld011.to(this.$refs.cloud011, { x: 50, y: 270, duration: 10});
      cld011.to(this.$refs.cloud011, { x: 75, y: 270, duration: 40});

      var cld012 = gsap.timeline({repeat: -1, yoyo: true});
      cld012.set(this.$refs.cloud012, { x: 55, y: 210, scale: 0.8, duration: 20});
      cld012.to(this.$refs.cloud012, { x: 50, y: 210, duration: 10});
      cld012.to(this.$refs.cloud012, { x: 55, y: 210, duration: 40});

		}
	}
}
</script>
<style scoped lang="scss">
.clouds {
  position: absolute;
  width: 100vw;
  height: 65vh;
  overflow: hidden;
  @media screen and (min-width: 1024px) {
    max-width: 1200px;
    left: 50%;
    transform: translate(-50%, 0);
  }
  .cloud {
    position: absolute;
  }
  .cld-01,
  .cld-07 {
    transform: translate(0, 20px);
    top: 5vh;
  }
  .cld-02 {
    transform: translate(400px, 10px), scale(0.5);
    top: 18vh;
  }
  .cld-03 {
    transform: translate(0, 30px), scale(0.15);
    top: 10vh;
  }
  .cld-04 {
    transform: translate(0, 30px), scale(0.25);
    top: 15vh;
  }
  .cld-05,
  .cld-11 {
    transform: translate(0, 30px), scale(0.35);
    top: 25vh;
  }
  .cld-06 {
    transform: translate(400px, 50px);
  }
  .cld-07 {
    transform: translate(700px, 150px);
  }
  .cld-08,
  .cld-12 {
    transform: translate(600px, 100px);
  }
  .cld-09 {
    transform: translate(0, 10px);
  }
  .cld-010 {
    transform: translate(20px, 10px);
  }
}
</style>
